import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Shield, Mail, Database, Lock, Eye, Trash2, FileText, Users } from 'lucide-react';

function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Header />
      <main className="flex-1 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 sm:p-10">
            <div className="flex items-center gap-3 mb-6">
              <Shield className="h-8 w-8 text-green-600" />
              <h1 className="text-2xl sm:text-3xl font-bold text-slate-900" style={{fontFamily: 'Manrope, sans-serif'}}>
                Ochrana osobných údajov
              </h1>
            </div>
            
            <p className="text-slate-600 mb-8">
              Posledná aktualizácia: {new Date().toLocaleDateString('sk-SK')}
            </p>

            <div className="space-y-8 text-slate-700">
              
              {/* Prevádzkovateľ */}
              <section>
                <div className="flex items-center gap-2 mb-3">
                  <Users className="h-5 w-5 text-green-600" />
                  <h2 className="text-xl font-semibold text-slate-900">1. Prevádzkovateľ</h2>
                </div>
                <div className="pl-7 space-y-2">
                  <p>Prevádzkovateľom osobných údajov je:</p>
                  <div className="bg-slate-50 p-4 rounded-lg">
                    <p><strong>EuroMed Slovensko s.r.o.</strong></p>
                    <p>Svätoplukova 4322/24</p>
                    <p>921 01 Piešťany</p>
                    <p className="mt-2">IČO: 36234478</p>
                    <p>IČ DPH: SK2020170284</p>
                    <p>DIČ: 2020170284</p>
                    <p className="mt-2">Web: www.evmarket.sk</p>
                    <p>E-mail: info@evmarket.sk</p>
                  </div>
                  <p className="text-sm text-slate-500">
                    (ďalej len „prevádzkovateľ" alebo „EVMarket")
                  </p>
                </div>
              </section>

              {/* Účel spracovania */}
              <section>
                <div className="flex items-center gap-2 mb-3">
                  <FileText className="h-5 w-5 text-green-600" />
                  <h2 className="text-xl font-semibold text-slate-900">2. Účel a právny základ spracovania</h2>
                </div>
                <div className="pl-7 space-y-4">
                  <p>Vaše osobné údaje spracúvame na tieto účely:</p>
                  
                  <div className="space-y-3">
                    <div className="border-l-4 border-green-500 pl-4">
                      <h3 className="font-semibold">a) Prevádzka inzertného portálu</h3>
                      <p className="text-sm">Spracúvame údaje potrebné na vytvorenie a zobrazenie inzerátov elektrických vozidiel. Právnym základom je plnenie zmluvy (čl. 6 ods. 1 písm. b) GDPR).</p>
                    </div>
                    
                    <div className="border-l-4 border-green-500 pl-4">
                      <h3 className="font-semibold">b) Registrácia a správa užívateľského účtu</h3>
                      <p className="text-sm">Údaje potrebné na vytvorenie účtu, prihlásenie a správu vašich inzerátov. Právny základ: plnenie zmluvy.</p>
                    </div>
                    
                    <div className="border-l-4 border-green-500 pl-4">
                      <h3 className="font-semibold">c) Komunikácia medzi používateľmi</h3>
                      <p className="text-sm">Umožnenie kontaktu medzi kupujúcimi a predávajúcimi prostredníctvom kontaktného formulára. Právny základ: oprávnený záujem.</p>
                    </div>
                    
                    <div className="border-l-4 border-green-500 pl-4">
                      <h3 className="font-semibold">d) Platené služby</h3>
                      <p className="text-sm">Spracovanie platieb za prémiové funkcie (propagácia inzerátov). Právny základ: plnenie zmluvy.</p>
                    </div>
                    
                    <div className="border-l-4 border-green-500 pl-4">
                      <h3 className="font-semibold">e) Bezpečnosť a prevencia podvodov</h3>
                      <p className="text-sm">Ochrana platformy pred zneužitím. Právny základ: oprávnený záujem prevádzkovateľa.</p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Rozsah údajov */}
              <section>
                <div className="flex items-center gap-2 mb-3">
                  <Database className="h-5 w-5 text-green-600" />
                  <h2 className="text-xl font-semibold text-slate-900">3. Rozsah spracúvaných údajov</h2>
                </div>
                <div className="pl-7">
                  <div className="overflow-x-auto">
                    <table className="min-w-full border border-slate-200 rounded-lg text-sm">
                      <thead className="bg-slate-100">
                        <tr>
                          <th className="px-4 py-2 text-left font-semibold">Kategória údajov</th>
                          <th className="px-4 py-2 text-left font-semibold">Konkrétne údaje</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border-t">
                          <td className="px-4 py-2 font-medium">Identifikačné údaje</td>
                          <td className="px-4 py-2">Meno, priezvisko, e-mailová adresa</td>
                        </tr>
                        <tr className="border-t bg-slate-50">
                          <td className="px-4 py-2 font-medium">Kontaktné údaje</td>
                          <td className="px-4 py-2">Telefónne číslo, mesto/obec (pri inzeráte)</td>
                        </tr>
                        <tr className="border-t">
                          <td className="px-4 py-2 font-medium">Údaje o inzeráte</td>
                          <td className="px-4 py-2">Popis vozidla, fotografie, cena, technické parametre</td>
                        </tr>
                        <tr className="border-t bg-slate-50">
                          <td className="px-4 py-2 font-medium">Prihlasovacie údaje</td>
                          <td className="px-4 py-2">E-mail, zahashované heslo, Google ID (pri OAuth)</td>
                        </tr>
                        <tr className="border-t">
                          <td className="px-4 py-2 font-medium">Technické údaje</td>
                          <td className="px-4 py-2">IP adresa, cookies, dátum a čas prístupu</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>

              {/* Doba uchovávania */}
              <section>
                <div className="flex items-center gap-2 mb-3">
                  <Lock className="h-5 w-5 text-green-600" />
                  <h2 className="text-xl font-semibold text-slate-900">4. Doba uchovávania údajov</h2>
                </div>
                <div className="pl-7 space-y-2">
                  <ul className="list-disc list-inside space-y-1">
                    <li><strong>Údaje o účte:</strong> po dobu existencie účtu + 3 roky po jeho zrušení</li>
                    <li><strong>Údaje o inzerátoch:</strong> po dobu zverejnenia + 1 rok po stiahnutí</li>
                    <li><strong>Komunikácia:</strong> 1 rok od odoslania správy</li>
                    <li><strong>Fakturačné údaje:</strong> 10 rokov (zákonná povinnosť)</li>
                    <li><strong>Technické logy:</strong> 6 mesiacov</li>
                  </ul>
                </div>
              </section>

              {/* Práva dotknutej osoby */}
              <section>
                <div className="flex items-center gap-2 mb-3">
                  <Eye className="h-5 w-5 text-green-600" />
                  <h2 className="text-xl font-semibold text-slate-900">5. Vaše práva</h2>
                </div>
                <div className="pl-7 space-y-3">
                  <p>Podľa GDPR a zákona o ochrane osobných údajov máte tieto práva:</p>
                  
                  <div className="grid sm:grid-cols-2 gap-3">
                    <div className="bg-green-50 p-3 rounded-lg">
                      <h4 className="font-semibold text-green-800">Právo na prístup</h4>
                      <p className="text-sm text-green-700">Môžete požiadať o kópiu vašich údajov</p>
                    </div>
                    <div className="bg-green-50 p-3 rounded-lg">
                      <h4 className="font-semibold text-green-800">Právo na opravu</h4>
                      <p className="text-sm text-green-700">Môžete opraviť nesprávne údaje</p>
                    </div>
                    <div className="bg-green-50 p-3 rounded-lg">
                      <h4 className="font-semibold text-green-800">Právo na vymazanie</h4>
                      <p className="text-sm text-green-700">„Právo byť zabudnutý"</p>
                    </div>
                    <div className="bg-green-50 p-3 rounded-lg">
                      <h4 className="font-semibold text-green-800">Právo na prenosnosť</h4>
                      <p className="text-sm text-green-700">Export údajov v štruktúrovanom formáte</p>
                    </div>
                    <div className="bg-green-50 p-3 rounded-lg">
                      <h4 className="font-semibold text-green-800">Právo namietať</h4>
                      <p className="text-sm text-green-700">Namietanie proti spracúvaniu</p>
                    </div>
                    <div className="bg-green-50 p-3 rounded-lg">
                      <h4 className="font-semibold text-green-800">Právo na obmedzenie</h4>
                      <p className="text-sm text-green-700">Obmedzenie spracúvania údajov</p>
                    </div>
                  </div>
                  
                  <p className="text-sm">
                    Svoje práva môžete uplatniť e-mailom na <strong>info@evmarket.sk</strong>. 
                    Na vašu žiadosť odpovieme do 30 dní.
                  </p>
                </div>
              </section>

              {/* Príjemcovia údajov */}
              <section>
                <div className="flex items-center gap-2 mb-3">
                  <Users className="h-5 w-5 text-green-600" />
                  <h2 className="text-xl font-semibold text-slate-900">6. Príjemcovia a sprostredkovatelia</h2>
                </div>
                <div className="pl-7 space-y-2">
                  <p>Vaše údaje môžu byť zdieľané s:</p>
                  <ul className="list-disc list-inside space-y-1">
                    <li><strong>Poskytovatelia hostingu:</strong> cloudové služby pre prevádzku webu</li>
                    <li><strong>Poskytovatelia autentifikácie:</strong> Google (pri prihlásení cez Google)</li>
                    <li><strong>Platobné brány:</strong> pri spracovaní platieb za prémiové služby</li>
                    <li><strong>E-mailové služby:</strong> zasielanie notifikácií a overovacích e-mailov</li>
                  </ul>
                  <p className="text-sm text-slate-500">
                    So všetkými sprostredkovateľmi máme uzatvorené zmluvy o spracúvaní osobných údajov.
                  </p>
                </div>
              </section>

              {/* Cookies */}
              <section>
                <div className="flex items-center gap-2 mb-3">
                  <Database className="h-5 w-5 text-green-600" />
                  <h2 className="text-xl font-semibold text-slate-900">7. Cookies a sledovacie technológie</h2>
                </div>
                <div className="pl-7 space-y-2">
                  <p>Používame tieto typy cookies:</p>
                  <ul className="list-disc list-inside space-y-1">
                    <li><strong>Nevyhnutné cookies:</strong> potrebné pre fungovanie webu (prihlásenie, bezpečnosť)</li>
                    <li><strong>Funkčné cookies:</strong> zapamätanie vašich preferencií</li>
                    <li><strong>Analytické cookies:</strong> anonymná analýza návštevnosti (so súhlasom)</li>
                  </ul>
                  <p className="text-sm">
                    Súhlas s cookies môžete kedykoľvek upraviť v nastaveniach prehliadača.
                  </p>
                </div>
              </section>

              {/* Bezpečnosť */}
              <section>
                <div className="flex items-center gap-2 mb-3">
                  <Lock className="h-5 w-5 text-green-600" />
                  <h2 className="text-xl font-semibold text-slate-900">8. Bezpečnosť údajov</h2>
                </div>
                <div className="pl-7 space-y-2">
                  <p>Implementovali sme primerané technické a organizačné opatrenia:</p>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Šifrovanie údajov pri prenose (HTTPS/TLS)</li>
                    <li>Hashovanie hesiel (bcrypt)</li>
                    <li>Pravidelné bezpečnostné aktualizácie</li>
                    <li>Obmedzený prístup k údajom</li>
                    <li>Dvojfaktorová autentifikácia pre administrátorov</li>
                  </ul>
                </div>
              </section>

              {/* Sťažnosti */}
              <section>
                <div className="flex items-center gap-2 mb-3">
                  <Mail className="h-5 w-5 text-green-600" />
                  <h2 className="text-xl font-semibold text-slate-900">9. Dozorný orgán</h2>
                </div>
                <div className="pl-7 space-y-2">
                  <p>
                    Ak sa domnievate, že spracúvanie vašich údajov porušuje GDPR, 
                    máte právo podať sťažnosť na dozorný orgán:
                  </p>
                  <div className="bg-slate-50 p-4 rounded-lg">
                    <p><strong>Úrad na ochranu osobných údajov Slovenskej republiky</strong></p>
                    <p>Hraničná 12, 820 07 Bratislava 27</p>
                    <p>Tel: +421 2 3231 3214</p>
                    <p>E-mail: statny.dozor@pdp.gov.sk</p>
                    <p>Web: <a href="https://dataprotection.gov.sk" className="text-green-600 hover:underline" target="_blank" rel="noopener noreferrer">dataprotection.gov.sk</a></p>
                  </div>
                </div>
              </section>

              {/* Záverečné ustanovenia */}
              <section>
                <div className="flex items-center gap-2 mb-3">
                  <FileText className="h-5 w-5 text-green-600" />
                  <h2 className="text-xl font-semibold text-slate-900">10. Záverečné ustanovenia</h2>
                </div>
                <div className="pl-7 space-y-2">
                  <p>
                    Tieto zásady ochrany osobných údajov sú platné a účinné od ich zverejnenia. 
                    Vyhradzujeme si právo tieto zásady kedykoľvek aktualizovať. 
                    O významných zmenách vás budeme informovať e-mailom alebo oznámením na webe.
                  </p>
                  <p className="text-sm text-slate-500">
                    Tieto zásady boli vypracované v súlade s Nariadením Európskeho parlamentu a Rady (EÚ) 2016/679 
                    (GDPR) a zákonom č. 18/2018 Z. z. o ochrane osobných údajov v znení neskorších predpisov.
                  </p>
                </div>
              </section>

            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PrivacyPolicyPage;
